import {Component, OnInit} from '@angular/core';
import {DocumentService} from '../../services/document.service';
import {Document, DocumentId} from '../../models/document.modal';
import {DocHelper} from '../../services/document.helper';
import {Router} from '@angular/router';

declare var $: any;

@Component({
    selector: 'app-doc-cookies-policy',
    templateUrl: './doc-cookies-policy.component.html',
    styleUrls: ['./doc-cookies-policy.component.scss'],
    standalone: false
})
export class DocCookiesPolicyComponent implements OnInit {

  docDetails: Document[] = [];
  DocumentId = DocumentId;
  printDoc = false;

  constructor(private documentService: DocumentService, public router: Router) {
    if (this.router.getCurrentNavigation()?.extras?.state) {
      this.printDoc = this.router.getCurrentNavigation()?.extras?.state?.print;
    }
  }

  ngOnInit(): void {
    this.documentService.getDocument(DocumentId.CookiesPolicy, 1)
      .subscribe((doc: Document[]) => {
        if (doc?.length) {
          this.docDetails = doc.sort((a, b) => a.index - b.index);
          $([document.documentElement, document.body]).animate({
            scrollTop: $('.page').offset().top
          }, 0);
          setTimeout(() => {
            if (this.printDoc) {
              window.print();
            }
          }, 1000);
        }
      });


  }

  getDocumentSection(sectionName = ''): any[] {
    return DocHelper.getDocumentSection(this.docDetails, sectionName);
  }

}
